"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTypedValue = void 0;
const core_1 = require("../core");
const readback_1 = require("../readback");
function formatTypedValue(mod, ctx, typedValue) {
    const typeCore = (0, readback_1.readbackType)(mod, ctx, typedValue.type);
    const core = (0, readback_1.readback)(mod, ctx, typedValue.type, typedValue.value);
    return `${(0, core_1.formatCore)(core)}: ${(0, core_1.formatCore)(typeCore)}`;
}
exports.formatTypedValue = formatTypedValue;
//# sourceMappingURL=formatTypedValue.js.map